import { render } from "./TemporaryConnection.vue?vue&type=template&id=00fe0537"
import script from "./TemporaryConnection.vue?vue&type=script&lang=js"
export * from "./TemporaryConnection.vue?vue&type=script&lang=js"

import exportComponent from "/__w/topwrap/topwrap/docs/build/kpm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__